import { createContext, useContext } from 'react';
import { useAdvisorSession } from '@/components/hooks/useAdvisorSession';

/**
 * AdvisorSessionContext — expone la {@link useAdvisorSession} a todo el árbol del
 * shell de asesor sin re-derivarla en cada ventana. El valor es el mismo objeto
 * que devuelve `useAdvisorSession()` (Path B; ver ese hook).
 */
const AdvisorSessionContext = createContext(/** @type {import('@/components/hooks/useAdvisorSession').AdvisorSession|null} */ (null));

export function AdvisorSessionProvider({ children }) {
  const session = useAdvisorSession();
  return (
    <AdvisorSessionContext.Provider value={session}>
      {children}
    </AdvisorSessionContext.Provider>
  );
}

/**
 * Lee la sesión de asesor del contexto. Debe usarse dentro de `<AdvisorShell>`.
 * @returns {import('@/components/hooks/useAdvisorSession').AdvisorSession|null}
 */
export function useAdvisorSessionContext() {
  return useContext(AdvisorSessionContext);
}

export default AdvisorSessionContext;
